import { Col, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import ArrowButton from "../arrow-button/arrow-button";
interface IProps {
  path: string;
  isPathIcon?: boolean;
  setIsAddUsage?: React.Dispatch<React.SetStateAction<boolean>>;
}

const SpacePathView = (props: IProps) => {
  const { path, isPathIcon = true, setIsAddUsage } = props;
  const navigate = useNavigate();

  return (
    <Row className="align-items-center mx-0">
      {isPathIcon && (
        <Col className="col-auto">
          <ArrowButton
            onBack={() => {
              if (setIsAddUsage) {
                setIsAddUsage(false);
                return;
              }

              navigate(-1);
            }}
          />
        </Col>
      )}
      <Col className="title-2 font-weight-500">
        Input Usage Schedule
        {/* <Row>
          <Col className="text-muted font-weight-400 font-size-14">
            {(path.split("split")[0] + path.split("split")[1]).length > 80
              ? shortenedPath(path.split("split")[0] + path.split("split")[1])
              : path.split("split")[0] + path.split("split")[1]}
          </Col>
        </Row>
        <Row>
          <Col className="text-dark font-weight-500 font-size-16">
            {path.split("split")[1]}
          </Col>
        </Row> */}
      </Col>
    </Row>
  );
};

export default SpacePathView;
